
import * as cloudinaryRuntime$_8meTUcLg3XvRaLoZ9jpLtAEryVMkPpR1GtwR947Cbzk from '/opt/render/project/src/frontend/node_modules/@nuxt/image/dist/runtime/providers/cloudinary'
import * as ipxRuntime$_4HadRR_45YfX_45_nYJU9XQFhT_ganJJkWi7h_45ajpd12Akw from '/opt/render/project/src/frontend/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudinary']: { provider: cloudinaryRuntime$_8meTUcLg3XvRaLoZ9jpLtAEryVMkPpR1GtwR947Cbzk, defaults: {"baseURL":"https://res.cloudinary.com/werkgeluk/image/upload/"} },
  ['ipx']: { provider: ipxRuntime$_4HadRR_45YfX_45_nYJU9XQFhT_ganJJkWi7h_45ajpd12Akw, defaults: {} }
}
        